import { render, staticRenderFns } from "./VideoCallPictureViewer.vue?vue&type=template&id=2915b2da&"
import script from "./VideoCallPictureViewer.vue?vue&type=script&lang=js&"
export * from "./VideoCallPictureViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports